export interface Trait {
  name: string;
  possibility: number;
  values: TraitValue[];
}

export interface TraitValuePair {
  trait: string;
  value?: string;
}

export interface TraitValue {
  trait: string;
  traitPossibility: number;
  name: string;
  possibility: number;
  layers: TraitLayer[];
  requires?: TraitValuePair[],
  depends?: TraitValuePair[],
  prevents?: TraitValuePair[],
}

export interface TraitLayer {
  image: string;
  layer: number;
}


export interface TraitValuesByPossibility {
  [ possibilityGroup: number ]: TraitValue[]
}


export interface NftAttribute {
  trait_type: string;
  value: string;
}

export interface NftMetadata {
  name: string;
  image: string;
  attributes: NftAttribute[]
  rarity: Rarity,
  dna: string;
  blurHash: string;
}

export interface NftData {
  tokenId: number;
  fileName: string;
  attributes: {
    [trait: string]: string
  },
  rarity: Rarity,
  dna: string;
  blurHash: string;
}

export enum Rarity {
  Common = 'Common',
  Uncommon = 'Uncommon', // 2+
  Rare = 'Rare', // 3 +
  Epic = 'Epic', // 4+ 20% items
  Legendary = 'Legendary', // 5+ 20% items
}

export interface RarityCounts {
  [Rarity.Common]: number;
  [Rarity.Uncommon]: number;
  [Rarity.Rare]: number;
  [Rarity.Epic]: number;
  [Rarity.Legendary]: number;
}


export interface NftStats {
  [trait: string] : {
    [value: string]: number
  }
}


export interface FilterData {
  [key: string] : {
    [value: string]: boolean
  }
}